// 00.000.000/0000-00
const mask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];

export default {
    mask: mask,
    guide: false,
    keepCharPositions: true,
    placeholderChar: '\u2000',
};
